import * as PIXI from "pixi";
import { Key } from "./Keyboard";

type Handler = (event: PIXI.InteractionEvent, pt: PIXI.Point) => void;

export default class Mouse {
  private displayObject: PIXI.DisplayObject;
  private downHandlers: Set<Handler> = new Set();
  private upHandlers: Set<Handler> = new Set();
  private moveHandlers: Set<Handler> = new Set();

  position: PIXI.Point = new PIXI.Point();
  get x() {
    return this.position.x;
  }
  get y() {
    return this.position.y;
  }

  constructor(displayObject: PIXI.DisplayObject) {
    this.displayObject = displayObject;
    displayObject.interactive = true;
    displayObject.on("pointerdown", this.onMouseDown.bind(this));
    displayObject.on("pointerup", this.onMouseUp.bind(this));
    displayObject.on("pointermove", this.onMouseMove.bind(this));

    console.log(this.downHandlers);
  }

  private getRelativePosition(event: PIXI.InteractionEvent) {
    return this.displayObject.toLocal(event.data.global);
  }

  private onMouseDown(event: PIXI.InteractionEvent) {
    for (const handler of this.downHandlers) {
      handler(event, this.getRelativePosition(event));
    }
  }
  private onMouseUp(event: PIXI.InteractionEvent) {
    for (const handler of this.upHandlers) {
      handler(event, this.getRelativePosition(event));
    }
  }
  private onMouseMove(event: PIXI.InteractionEvent) {
    if (event.target === null) return; // Outside the displayObject
    this.position = this.getRelativePosition(event);
    for (const handler of this.moveHandlers) {
      handler(event, this.position);
    }
  }

  down(handler: Handler) {
    this.downHandlers.add(handler);
  }
  up(handler: Handler) {
    this.upHandlers.add(handler);
  }
  move(handler: Handler) {
    this.moveHandlers.add(handler);
  }

  undown(handler: Handler) {
    this.downHandlers.delete(handler);
  }
  unup(handler: Handler) {
    this.upHandlers.delete(handler);
  }
  unmove(handler: Handler) {
    this.moveHandlers.delete(handler);
  }
}
